import { useEffect } from 'react';

// Use beforeunload to prevent closing the tab, refreshing the page or moving outside the app
export const useConfirmNavigateAway = (shouldWarn: boolean) => {
  useEffect(() => {
    const handleWindowClose = (e: BeforeUnloadEvent) => {
      if (!shouldWarn) return;
      e.preventDefault();
      const event = e || window.event;
      return (event.returnValue = 'Are you sure you want to leave?');
    };

    window.addEventListener('beforeunload', handleWindowClose);
    return () => {
      window.removeEventListener('beforeunload', handleWindowClose);
    };
  }, [shouldWarn]);
};
